import React from 'react';

import { useLocalizedNumericSeparators } from '@/hooks/useLocalizedNumericSeparators';

interface ToNumberInterface {
  (value: string): number;
}

export const useLocalizedToNumber = (): ToNumberInterface => {
  const { decimalSeparator, groupSeparator } = useLocalizedNumericSeparators();

  return React.useCallback(
    (value: string): number => {
      return Number(value.replaceAll(groupSeparator, '').replaceAll(decimalSeparator, '.'));
    },
    [decimalSeparator, groupSeparator],
  );
};
